export const ADMIN_GET_NDA_AGREEMENT = "ADMIN_GET_NDA_AGREEMENT"
export const ADMIN_GET_NDA_AGREEMENT_SUCCESS = "ADMIN_GET_NDA_AGREEMENT_SUCCESS"
export const ADMIN_GET_NDA_AGREEMENT_FAILED = "ADMIN_GET_NDA_AGREEMENT_FAILED"